import './TimeZoneSelector.css';

/**
 * TimeZoneSelector Component
 * Timezone selection matching mockUI.html design
 */
const TimeZoneSelector = ({ selectedTimezone, onTimezoneChange }) => {
  const commonTimezones = [
    { code: 'local', name: 'Local Time' },
    { code: 'America/Los_Angeles', name: 'USA, Pacific' },
    { code: 'America/Chicago', name: 'USA, Central' },
    { code: 'America/New_York', name: 'USA, Eastern' },
    { code: 'Europe/London', name: 'UK' },
    { code: 'Europe/Berlin', name: 'Central Europe' },
    { code: 'Asia/Jerusalem', name: 'Israel' },
    { code: 'Asia/Kolkata', name: 'India' },
    { code: 'Asia/Shanghai', name: 'China' },
  ];

  const allTimezones = [
    { code: 'local', name: 'Local Time' },
    { code: 'America/Los_Angeles', name: 'USA, Pacific (PT)' },
    { code: 'America/Chicago', name: 'USA, Central (CT)' },
    { code: 'America/New_York', name: 'USA, Eastern (ET)' },
    { code: 'America/Mexico_City', name: 'Mexico City (CST)' },
    { code: 'America/Sao_Paulo', name: 'Brazil (BRT)' },
    { code: 'Europe/London', name: 'UK (GMT/BST)' },
    { code: 'Europe/Berlin', name: 'Central Europe (CET/CEST)' },
    { code: 'Europe/Paris', name: 'Paris (CET/CEST)' },
    { code: 'Asia/Dubai', name: 'Dubai (GST)' },
    { code: 'Asia/Jerusalem', name: 'Israel (IST)' },
    { code: 'Asia/Kolkata', name: 'India (IST)' },
    { code: 'Asia/Singapore', name: 'Singapore (SGT)' },
    { code: 'Asia/Shanghai', name: 'China (CST)' },
    { code: 'Asia/Seoul', name: 'South Korea (KST)' },
    { code: 'Asia/Tokyo', name: 'Tokyo (JST)' },
    { code: 'Australia/Sydney', name: 'Sydney (AEDT/AEST)' },
  ];

  return (
    <div className="timezone-bar">
      {commonTimezones.map(tz => (
        <span
          key={tz.code}
          className={selectedTimezone === tz.code ? 'active-tz' : ''}
          onClick={() => onTimezoneChange(tz.code)}
        >
          {tz.name}
        </span>
      ))}

      <span style={{ marginLeft: 'auto' }}>
        <select
          value={selectedTimezone}
          onChange={(e) => onTimezoneChange(e.target.value)}
        >
          <option value="">Select Timezone</option>
          {allTimezones.map(tz => (
            <option key={tz.code} value={tz.code}>
              {tz.name}
            </option>
          ))}
        </select>
      </span>
    </div>
  );
};

export default TimeZoneSelector;
